import React from "react";
import { Form, Input, Button, Select } from "antd";
import countries from "world-countries";

const UserForm = ({ form, onFinish, loading, isEdit = false }) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please enter name" }]}
      >
        <Input placeholder="Enter name" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Please enter email" },
          { type: "email", message: "Enter valid email" },
        ]}
      >
        <Input placeholder="Enter email" disabled={isEdit} />
      </Form.Item>

      {!isEdit && (
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter password" }]}
        >
          <Input.Password placeholder="Enter password" />
        </Form.Item>
      )}

      <Form.Item
        label="Mobile Number"
        name="mobileNumber"
        rules={[
          { required: true },
          {
            pattern: /^[0-9]{10}$/,
            message: "Enter valid 10-digit number",
          },
        ]}
      >
        <Input placeholder="Enter mobile number" />
      </Form.Item>

      <Form.Item
        label="Country"
        name="country"
        rules={[{ required: true, message: "Please select country" }]}
      >
        <Select
          showSearch
          placeholder="Select country"
          options={countries.map((c) => ({
            label: c.name.common,
            value: c.name.common,
          }))}
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} block>
          {isEdit ? "Update User" : "Add User"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default UserForm;
